import { render } from "./AboutAccordian.vue?vue&type=template&id=7c525d7d&scoped=true"
import script from "./AboutAccordian.vue?vue&type=script&lang=js"
export * from "./AboutAccordian.vue?vue&type=script&lang=js"

import "./AboutAccordian.vue?vue&type=style&index=0&id=7c525d7d&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/Israr/vue/matrixlimos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c525d7d"]])

export default __exports__